<template>
  <div class="min-height-for-section w-100 pt-livetv">
    <div class="container-fluid">
      <div class="row mt-4 mx-3 mb-3">
        <div class="col-12 text-left mb-4 pl-3">
          <h4 class="mb-5">GOVERNMENT OF BRUNEI DARUSSALAM PRIVACY STATEMENT</h4>

          <p>
            1) This is a Government of His Majesty The Sultan and Yang
            Di-Pertuan of Brunei Darussalam website. Thank you for examining our
            privacy statement.
          </p>

          <p>
            2) If you are only browsing this website, we do not capture data
            that allows us to identify you individually.
          </p>

          <p>
            If you choose to make an application or send us an e-mail for which
            you provide us with personally identifiable data, we may share
            necessary data with other Government agencies, so as to serve you in
            a most efficient and effective way, unless such sharing is
            prohibited by legislation. We will NOT share your personal data with
            non-Government entities, except where such entities have been
            authorised to carry out specific Government services.
          </p>

          <p>
            3) For your convenience, we may also display to you data you had
            previously supplied us or other Government agencies. This will speed
            up the transaction and save the trouble of repeating previous
            submissions. Should the data be out-of-date, please supply us the
            latest data. We will retain your personal data only as necessary for
            the effective delivery of public services to you.
          </p>

          <p>
            4) To safeguard your personal data, all electronic storage and
            transmission of personal data are secured with appropriate security
            technologies.
          </p>

          <p>
            5) This site may contain links to non-Government sites whose data
            protection and privacy practices may differ from ours. We are not
            responsible for the content and privacy practices of these other
            websites and encourage you to consult the privacy notices of those
            sites.
          </p>

          <section class="data-deletion" aria-labelledby="data-deletion-title">
            <p id="data-deletion-title">
              6) RTBGo Account and Data Deletion
            </p>

            <p>
              This deletion process applies to RTBGo accounts used on the
              RTBGo website, mobile application and Android TV application.
            </p>

            <p>To request deletion of your RTBGo account and personal data:</p>

            <ol>
              <li>
                Send an email to
                <a
                  href="mailto:it.rtbbn@gmail.com?subject=RTBGo%20Account%20Deletion%20Request"
                  >it.rtbbn@gmail.com</a
                >
                with the subject <strong>RTBGo Account Deletion Request</strong>.
              </li>
              <li>
                Send the request from the email address registered to your
                RTBGo account and include your RTBGo username. Do not include
                your password.
              </li>
              <li>
                RTB may contact you using your registered email address to
                verify that you own the account before processing the request.
              </li>
            </ol>

            <p>
              After ownership is verified, RTB will delete the RTBGo account
              and personal data associated with it, including profile details
              and account-linked viewing activity. RTB will send a confirmation
              to the registered email address when the request has been
              completed.
            </p>

            <p>
              Limited information may be retained where required by applicable
              law, to prevent fraud or abuse, to protect the security of RTBGo,
              or to resolve an active dispute. Any retained information will be
              kept only for the purpose and period for which it is required and
              will then be deleted or anonymised.
            </p>

            <p>
              If you do not have an RTBGo account but want personal information
              you previously submitted to RTBGo to be deleted, use the same
              email address and describe the information and how it was
              submitted so that RTB can locate your request.
            </p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
export default {
  data: function() {
    return {};
  },
  components: {
    BreadCrumbsHeader,
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 10px 0 0;
  min-height: 80vh;
}
.breadCrumbsWrapper {
  padding: 30px;
}

@media only screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
.bg {
  background: #292929;
  height: auto !important; /* cross-browser */
  height: 100%; /* cross-browser */
  /* margin-bottom: 120px; */
}
.bg_header {
  background: url("../assets/headerbg.png");
  background-size: cover;
}
.bg_text {
  font-family: Sf-ui-medium;
  font-size: 35px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: 1.75px;
  text-align: center;
  color: #ffffff;
}
.channel_logo {
  padding: 40px 0px;
}
h4 {
  color: #fab900;
  font-family: "Poppins", sans-serif !important;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 24px;
  text-align: center;
}
p {
  font-family: "Poppins", sans-serif !important;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 22px;
  color: #cccccc;
  padding: 0 0 10px;
}
.data-deletion {
  margin-top: 24px;
}
.data-deletion ol {
  margin: 0 0 20px;
  padding-left: 24px;
  color: #cccccc;
  font-family: "Poppins", sans-serif !important;
  font-size: 16px;
  line-height: 22px;
}
.data-deletion li {
  margin-bottom: 12px;
}
.data-deletion a {
  color: #fab900;
  text-decoration: underline;
}
.data-deletion strong {
  color: #ffffff;
}
@media only screen and (max-width: 480px) {
  .carousel_title {
    font-size: 20px;
  }
  .items_title {
    font-size: 14px;
  }
  .bg_text {
    font-size: 30px;
  }
}
</style>
